import type { MarketplaceTutorThemeState } from "#/src/hooks/marketplaceTutorThemeUtils";
import { createContext, useContext } from "react";

const DEFAULT_STATE: MarketplaceTutorThemeState = {
  analyticsMetadata: {
    marketplaceTutorThemeBrand: "classdojo",
    marketplaceTutorThemeEnabled: false,
    marketplaceTutorThemeSurface: "none",
  },
  brand: "classdojo",
  isTutorTheme: false,
  surface: "none",
};

export const MarketplaceTutorThemeContext = createContext<MarketplaceTutorThemeState>(DEFAULT_STATE);

export function useMarketplaceTutorTheme() {
  return useContext(MarketplaceTutorThemeContext);
}
